module.exports = __webpack_public_path__ + "img/shield_selected.d13f664f.png";